import request from '../helpers/request';

const updateRequestMaster = async (requestId, masterId) => {
  return await request.put(
    `/Request/set_master/${requestId}`,
    masterId,
    'Не удалось назначить мастера'
  );
};

export default updateRequestMaster;
